import { useQuery, useMutation } from '@tanstack/react-query'
import { GeneralSettingsParams } from '@/types/setting'
import { useGeneralSettingsStore } from '@/store'

export const useGeneralSettings = () => {
  const { getGeneralSettings } = useGeneralSettingsStore()

  return useQuery({
    queryKey: ['generalSettings'],
    queryFn: () => getGeneralSettings(),
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000
  })
}

export const useUpdateGeneralSettings = () => {
  const { updateGeneralSettings } = useGeneralSettingsStore()

  return useMutation({
    mutationFn: (data: GeneralSettingsParams) => updateGeneralSettings(data),
    throwOnError: false
  })
}
